import React, { useContext, useState } from 'react';
import cl from './Pagination.module.css'
import Select from "react-select"; 
import { selectStyle } from './selectStyle';
import { AppContext } from '../../../providers/appProvider';
import { useTranslation } from 'react-i18next';
 
const Pagination = ({children, total, perPage, current, paginate, setLimit}) => {
  const { t } = useTranslation();
  
  const neighbors = 2;
  const totalPages = Math.ceil(total / perPage);
  const { appState, app } = useContext(AppContext);

  let startPage = Math.max(current - neighbors, 1);
  let endPage = Math.min(current + neighbors, totalPages);

  if (current <= neighbors) {
    endPage = Math.min(neighbors * 2 + 1, totalPages);
  } else if (current > totalPages - neighbors) {
    startPage = Math.max(totalPages - neighbors * 2, 1);
  }

  const pages = Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index);

  const pagesOptions = Array.from({ length: endPage - startPage + 1 }, (_, index) => ({
    value: startPage + index,
    label: `Page ${startPage + index}`  
  }));
  
 
 
  const handleInputChange = (event) => {
    const intVal = parseInt(event.target.value, 10);
    if (!isNaN(intVal)) {
      setLimit(intVal);
    }   
  }
  
 
  const handleSelectChange = (event) => {
     const intVal = parseInt(event.target.value, 10);
    if (!isNaN(intVal)) {
      setLimit(intVal);
    }
  }
 

  const handleSelectChangePage = (event) => {
    const intVal = parseInt(event.target.value, 10);
   if (!isNaN(intVal)) {
     customPaginate(intVal); 
   }
 }

  const customPaginate = (page) => {
     if (current !== page) {
      paginate(page) 
     }
   }

  return (
    <div className={cl.pagiBox}>
 
        <div className={ cl.perPage }>
            
            <select value={perPage} onChange={handleSelectChange}>
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>   
            <option value="100">100</option>   
            </select>
            {t('Total')} <span>{ total }</span> 
        </div>
 
        <div className={ cl.childrenPagi }>
        { children }
        </div>
        
        <ul className={cl.pagination}>  

            {current > 1 && (
                <li><span onClick={() => customPaginate(1)} >‹‹</span></li>
            )}
            {current > 1 && (
                <li><span onClick={() => customPaginate(current-1)}>‹</span></li>
            )}

            {pages.map(page => (
            <li key={page} className={` ${current === page ? cl.active : ' '}`} >
                <span onClick={() => customPaginate(page)} >
                {page}
                </span>
            </li>
            ))} 
        
            {current < totalPages && (
            <li><span onClick={() => customPaginate(current+1)} >›</span></li>
            )}
            {current !== totalPages && (
            <li><span onClick={() => customPaginate(totalPages)} >››</span></li>
            )}

        </ul>

         
        <select className={cl.selectPage} value={current} onChange={handleSelectChangePage}>
            

        {Array.from({ length: totalPages }).map((_, index) => (
                <option key={index} value={index +1 }>{index +1}</option>  
            ))}

        </select>

    </div>
  );
};

export default Pagination;